<template>
    <div>

        <!-- Table -->

        <trax-ui-card-plain-header-with-actions :title="lang.polaris.training.program_items" :actions="card_actions" :bus="bus">
            <trax-ui-ajax-struct-table-with-actions :id="id" :bus="bus" :endpoint="endpoint" 
                :index-id="programId" drag="1" :edit-url-map="editUrlMap">
            </trax-ui-ajax-struct-table-with-actions>
        </trax-ui-card-plain-header-with-actions>

        <!-- Editing modal -->

        <trax-ui-modal-default :id="id+'-edit'" :bus="bus">
            <trax-ui-struct-item-form :id="id+'-edit'" :toastr-id="id+'-toastr'" :bus="bus" :endpoint="endpoint" :type-code="typeCode" :type-code-select="aggregation_types_select" 
                :index-id="programId" with-description="1">
            </trax-ui-struct-item-form>
        </trax-ui-modal-default>

        <!-- Delete confirm modal -->

        <trax-ui-modal-confirm :id="id+'-delete'" :title="lang.polaris.form.deletion" :bus="bus">
            {{ lang.polaris.training.confirm_delete_course_q }}
        </trax-ui-modal-confirm>

        <!-- Toastr -->

        <trax-ui-toastr :id="id+'-toastr'" :bus="bus" passed-label="1" no-progress="1">
        </trax-ui-toastr>
    
    </div>
</template>

<script>
    export default {
    
        props: {
            id: {default: 'trax-training-program-edit-items'},
            typeCode: {default: 'standard-course'},
            programId: null
        },
    
        data: function() {
            return {
                lang: lang,
                endpoint: app_url+'polaris/api/front/phases',
                aggregation_types_select: data.aggregation_types_select,
                card_actions: [
                    { icon: 'add_box', event: this.id+'-edit-create' }
                ],
                editUrlMap: {
                    prop: 'type',
                    map: data.aggregation_edit_routes
                },
                bus: new Vue()
            }
        }
    }
</script>
